import { createContext } from "react";

const dragContext = createContext()

export default dragContext

